// extracted by mini-css-extract-plugin
export var error = "FormError-module--error--62f60";
export var title = "FormError-module--title--7210f";
export var shake = "FormError-module--shake--439cf";
export var animation = "FormError-module--animation--b6c11";
export var scrollLeft = "FormError-module--scroll-left--830b6";